import React from 'react';
import PropTypes from 'prop-types';
import { Users } from 'lucide-react';

// Same empty-state shell AssignmentPipeline.jsx used inline before this
// tabs/ folder existed — factored out so each tab can supply its own copy
// without re-implementing the icon/title/description layout six times.
const TabEmptyState = ({ title, description }) => (
  <div className="flex flex-col items-center justify-center py-[60px] px-5 text-center bg-card rounded-lg border border-border rounded-tl-none rounded-tr-none">
    <div className="w-[72px] h-[72px] rounded-full bg-border flex items-center justify-center mb-5">
      <Users className="w-8 h-8 text-muted-foreground" strokeWidth={1.5} />
    </div>
    <p className="text-[15px] font-semibold text-foreground-strong mb-1.5 tracking-[-0.01em]">
      {title}
    </p>
    <p className="text-[13px] text-muted-foreground leading-[1.6] max-w-[320px]">
      {description}
    </p>
  </div>
);

TabEmptyState.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

TabEmptyState.defaultProps = {
  title: 'No candidates found',
  description: 'No candidates match the current stage. Try a different tab.',
};

export default TabEmptyState;
